import io from 'socket.io-client';
import { setStatusAnalyzeFile } from '../store/slices/uploadAndAnalyzeAI';
import showMessage from './showSocketMessage';
let socket = '';
let dispatch = null;
export const createSocket = (user, _dispatch) => {
  socket = io(process.env.REACT_APP_API_URL, {
    withCredentials: true,
  });
  dispatch = _dispatch;
  socket.on('connect', () => {
    if (user) {
      socket.emit('get-user-data', {
        id: user.id,
      });
    }
  });
  socket.on('connect_error', (err) => {
    console.error(err.message);
  });
};
export const uploadFile = (file) => {
  if (!dispatch)
    return;
  dispatch(setStatusAnalyzeFile({ status: 'loading', records: null }));
  socket.emit('upload-file', {
    name: file.name,
    type: file.type,
    size: file.size,
    buffer: file,
  });
  socket.once('file-uploaded', ({ success, message }) => {
    dispatch(setStatusAnalyzeFile({ status: success, records: message }));
    showMessage(success === 'success' ? 'File uploaded' : message, success === 'failed' ? 'error' : 'info');
  });
};
export const disconnectSocket = () => {
  if (socket)
    return socket.disconnect();
};
